import React, { useEffect, useState } from "react";
import "./stylestabs.scss";
import { SettingOutlined } from "@ant-design/icons";
import { avatar, info_cicrle } from "../../../components/ExportImgFigma";
import { FlattenedField } from "../../CustomersV2/indexV2";
import { ListField } from "../../../api/Customer_V2/customerApi_V2";
import useToast from "../../../hook/useToast";
import { ICustomerDetail_V4 } from "../../../api/customer/customerApi";
import { NO_DATA, URL_AVATAR } from "../../../env";
import { capitalizeEachWord, getTitleSelectOption } from "../../../until";
import { Tooltip } from "antd";
import { ISelectOption } from "../../../api/selectOptions/selectOptionsApi";
import CustomerFeilds from "../../CustomersV2/Drawer/CustomerFeilds";
import { NO_VIEW } from "../../../services/data";

const dataListFieldsByCustomerRecordActive = [
  {
    "id": 1,
    "title": "Thông tin dòng xe",
    "fields": [
      {
        "id": 2,
        "fieldCode": "carLine",
        "fieldLabel": "Tên dòng xe",
        "inputType": "string",
        "isActive": 1
      },
      {
        "id": 3,
        "fieldCode": "status",
        "fieldLabel": "Trạng thái",
        "inputType": "string",
        "isActive": 1
      }
    ]
  }
]

const dataListFieldsByCustomerRecordNotActive = [
  {
    "id": 1,
    "title": "Thông tin dòng xe",
    "fields": [
    ]
  }
]
interface Prop {
  sLTypePhone: ISelectOption[]
  infoCustomer?: ICustomerDetail_V4;
}

const Infomation: React.FC<Prop> = ({
  sLTypePhone, infoCustomer
}) => {
  const pushToast = useToast();

  useEffect(() => {
    // gListFieldsActive()
    return (() => {

    })
  }, [])

  const [isSettingShow, setSettingShow] = useState(false)


  const [dataFilterActive, setDataFilterActive] = useState<FlattenedField[]>([])
  const [dataFilterNoActive, setDataFilterNoActive] = useState<ListField[]>([])

  const gListFieldsActive = async () => {
    const flattenedFields = await dataListFieldsByCustomerRecordActive.flatMap(choice =>
      choice.fields.map(field => ({
        ...field,
        parentId: choice.id,
      }))
    );
    setDataFilterActive(flattenedFields)
    gListFieldsNotActive()
  }

  const gListFieldsNotActive = async () => {
    setDataFilterNoActive(dataListFieldsByCustomerRecordNotActive)
  }

  const onSaveDataFields = (iSsuccess?: boolean, message?: string, dataFilterActive?: FlattenedField[], dataFilterNoActive?: ListField[]) => {
    if (iSsuccess) {
      setSettingShow(false)
      pushToast(message, "success")
      setDataFilterActive(dataFilterActive ?? [])
      setDataFilterNoActive(dataFilterNoActive ?? [])

    } else {
      pushToast(message, "warning")
    }
  }


  return (
    <>
      {/* {
        isSettingShow ?
          <CustomerFeilds
            isSettingShow={isSettingShow}
            type={1}
            dataFilterActive={dataFilterActive}
            dataFilterNoActive={dataFilterNoActive}

            onSaveDataFields={onSaveDataFields}
            onClose={() => setSettingShow(false)}
          /> :
          null
      } */}
      <div className="user-info-container position-relative">
        <div className="info-section">
          <div className="avatar-container">
            <div className="avatar">
              <img
                src={URL_AVATAR + infoCustomer?.image}
                alt="Avatar"
                onError={(e) => {
                  e.currentTarget.src = avatar;
                }}
              />
            </div>
          </div>
          <div className="info-content">
            <label className="info-label font-light  text-000000">Họ và tên</label>
            <div className="info-value font-medium  text-000000">


              {/* {
                 username: boolean
                 phone: boolean
                 gender: boolean
                 statusMarital: boolean
                 code: boolean
                 invoiceSaleDocDate: boolean
                 totalOwnerVehicles: boolean
                 totalVehiclePassenger: boolean
                 totalVehicleBus: boolean
                 totalServiceAmount: boolean
                 totalPurchaseAmount: boolean
                 totalAmount: boolean
                 totalServiceInvoices: boolean
                 totalPurchaseInvoices: boolean
               } */}
              {infoCustomer?.permissions?.username ? ((infoCustomer && infoCustomer.userName && infoCustomer?.userName.length > 0) ? capitalizeEachWord(infoCustomer?.userName[0]?.username ?? '') : NO_DATA) : NO_VIEW}

            </div>
          </div>
        </div>

        <div className="info-section">
          <div className="info-content">
            <label className="info-label font-light  text-000000">Mã định danh khách hàng</label>
            <div className="info-value font-medium  text-000000">

              {infoCustomer?.permissions?.username ? infoCustomer?.code : NO_VIEW}
            </div>
          </div>
        </div>

        <div className="info-section">
          <div className="info-content">
            <label className="info-label font-light  text-000000">Số điện thoại</label>
            {infoCustomer?.permissions?.phone ?
              <div className="info-value font-medium action-icons">
                {infoCustomer?.phone[0]?.phone}
                <span className="company-tag font-light">
                  ( {getTitleSelectOption(sLTypePhone, infoCustomer?.phone[0]?.categoryPhoneId ?? 2)} )
                </span>
                {
                  infoCustomer?.phone && infoCustomer?.phone?.length > 1 ? (
                    <Tooltip
                      placement="right"
                      color="white"

                      title={
                        <div
                          style={{
                            maxHeight: 400,       // chiều cao cố định
                            overflowY: "auto",    // bật scroll dọc
                          }}
                          className="space-y-2"
                        >
                          {infoCustomer?.phone?.map((item, i) => (
                            <div key={i} className="flex items-center gap-2">
                              <span className="color-bage-custom fs-14">
                                {item.phone}
                              </span>
                              <span className="color-gold-main fs-14">
                                ( {getTitleSelectOption(sLTypePhone, item.categoryPhoneId)} )
                              </span>
                            </div>
                          ))}
                        </div>
                      }
                    >
                      <div className="action-icons action-icons-bage ml-auto px-2 fs-14 cursor-pointer">
                        <div className="font-light color-bage">
                          {infoCustomer?.phone?.length}
                        </div>
                        <img src={info_cicrle} alt="Avatar" />
                      </div>
                    </Tooltip>
                  ) :
                    null
                }

              </div>


              : <div className="info-value font-medium  text-000000">******   </div>}

          </div>
          {/* <div
            className="icon-svg-infomartion w-6 h-6 d-flex justify-center align-center cursor-pointer border-D9D9D9 rounded-2 color-icon-setting"
            onClick={() => setSettingShow(true)}
          >
            <SettingOutlined />
          </div> */}
        </div>
      </div >
    </>
  );
};


export default Infomation;
